/**
 * Priyoraa Shopify Theme Scripts
 * Full AJAX Cart & Shopify Theme 2.0 Interactivity
 */

document.addEventListener('DOMContentLoaded', () => {
  const backdrop = document.getElementById('backdrop');
  const cartDrawer = document.getElementById('cart-drawer');
  const quickViewModal = document.getElementById('quick-view-modal');
  const searchModal = document.getElementById('search-modal');
  const megaMenuDrawer = document.getElementById('mega-menu-drawer');

  // Drawer Helpers
  const openDrawer = (drawer) => {
    if (!drawer) return;
    drawer.classList.add('active');
    backdrop?.classList.add('active');
    document.body.classList.add('modal-open');
  };

  const closeAll = () => {
    document.querySelectorAll('.drawer, .modal, .mobile-filter-drawer').forEach(el => el.classList.remove('active'));
    backdrop?.classList.remove('active');
    document.body.classList.remove('modal-open');
  };

  backdrop?.addEventListener('click', closeAll);
  document.querySelectorAll('.drawer-close-btn').forEach(btn => btn.addEventListener('click', closeAll));

  // Toggle Cart Drawer
  document.querySelectorAll('[data-action="open-cart"]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openDrawer(cartDrawer);
      refreshCartDrawer();
    });
  });

  // Toggle Mega Menu
  document.getElementById('btn-toggle-menu')?.addEventListener('click', () => {
    openDrawer(megaMenuDrawer);
  });

  // Toggle Search Modal
  document.querySelectorAll('[data-action="open-search"]').forEach(btn => {
    btn.addEventListener('click', () => {
      openDrawer(searchModal);
      setTimeout(() => document.getElementById('search-modal-input')?.focus(), 100);
    });
  });

  // AJAX Add to Cart
  document.addEventListener('click', (e) => {
    const addBtn = e.target.closest('[data-action="add-to-cart"]');
    if (addBtn) {
      e.preventDefault();
      const variantId = addBtn.dataset.variantId;
      const qty = parseInt(addBtn.dataset.quantity || '1', 10);
      if (!variantId) return;

      addBtn.disabled = true;
      const originalText = addBtn.innerHTML;
      addBtn.innerHTML = '<span>Adding...</span>';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
      .then(res => res.json())
      .then(item => {
        addBtn.disabled = false;
        addBtn.innerHTML = originalText;
        openDrawer(cartDrawer);
        refreshCartDrawer();
      })
      .catch(err => {
        console.error('Error adding to cart', err);
        addBtn.disabled = false;
        addBtn.innerHTML = originalText;
      });
    }
  });

  // Refresh Cart Drawer
  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        // Update header badge
        document.querySelectorAll('.cart-count-badge').forEach(badge => {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });

        // Update Drawer Content
        const itemsContainer = document.getElementById('cart-drawer-items');
        const subtotalEl = document.getElementById('cart-drawer-subtotal');
        const progressFill = document.getElementById('cart-shipping-progress');
        const progressText = document.getElementById('cart-shipping-text');

        if (subtotalEl) {
          subtotalEl.textContent = '₹' + (cart.total_price / 100).toFixed(0);
        }

        // Free shipping calculation (₹499 threshold = 49900 paise)
        const threshold = 49900;
        if (progressFill && progressText) {
          if (cart.total_price >= threshold) {
            progressFill.style.width = '100%';
            progressText.innerHTML = '🎉 You unlocked <strong>FREE Express Shipping</strong>!';
          } else {
            const pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
            const remaining = ((threshold - cart.total_price) / 100).toFixed(0);
            progressFill.style.width = pct + '%';
            progressText.innerHTML = `Add <strong>₹${remaining}</strong> more for Free Shipping!`;
          }
        }

        if (itemsContainer) {
          if (cart.item_count === 0) {
            itemsContainer.innerHTML = `
              <div style="text-align: center; padding: 4rem 1rem; color: var(--color-gray-medium);">
                <i class="ri-shopping-bag-line" style="font-size: 3rem; margin-bottom: 1rem; display: block;"></i>
                <h4 style="font-size: 1.1rem; font-weight: 700; color: var(--color-dark);">Your Bag is Empty</h4>
                <p style="font-size: 0.85rem; margin-top: 0.25rem;">Looks like you haven't added anything yet.</p>
              </div>
            `;
          } else {
            itemsContainer.innerHTML = cart.items.map(item => `
              <div class="cart-item-card" data-key="${item.key}">
                <img src="${item.featured_image ? item.featured_image.url : ''}" alt="${item.title}" class="cart-item-img" />
                <div class="cart-item-info">
                  <h4 class="cart-item-title">${item.product_title}</h4>
                  ${item.variant_title && item.variant_title !== 'Default Title' ? `<span class="cart-item-variant">${item.variant_title}</span>` : ''}
                  <span class="cart-item-price">₹${(item.final_line_price / 100).toFixed(0)}</span>
                  <div class="cart-qty-ctrl">
                    <button class="qty-btn" data-action="change-qty" data-key="${item.key}" data-qty="${item.quantity - 1}">-</button>
                    <span class="qty-input">${item.quantity}</span>
                    <button class="qty-btn" data-action="change-qty" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
                  </div>
                </div>
                <button class="cart-item-remove" data-action="change-qty" data-key="${item.key}" data-qty="0" title="Remove">
                  <i class="ri-delete-bin-line"></i>
                </button>
              </div>
            `).join('');
          }
        }
      });
  }

  // Handle Qty Changes in Cart Drawer
  document.addEventListener('click', (e) => {
    const qtyBtn = e.target.closest('[data-action="change-qty"]');
    if (qtyBtn) {
      e.preventDefault();
      const lineKey = qtyBtn.dataset.key;
      const newQty = parseInt(qtyBtn.dataset.qty, 10);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: newQty })
      })
      .then(res => res.json())
      .then(() => refreshCartDrawer());
    }
  });

  // PDP Image Switcher
  document.querySelectorAll('.pdp-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.src;
      const mainImg = document.getElementById('pdp-main-img');
      if (mainImg && src) mainImg.src = src;
      document.querySelectorAll('.pdp-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // Accordion Toggles
  document.querySelectorAll('.accordion-header').forEach(hdr => {
    hdr.addEventListener('click', () => {
      const parent = hdr.parentElement;
      const body = parent.querySelector('.accordion-body');
      const icon = hdr.querySelector('i');
      const isOpen = body.style.display === 'block';
      body.style.display = isOpen ? 'none' : 'block';
      if (icon) icon.className = isOpen ? 'ri-arrow-right-s-line' : 'ri-arrow-down-s-line';
    });
  });
});
